module.exports = __webpack_public_path__ + "static/media/image5.4a638bfa.jpg";